import { LocalStorageService } from '.';

const KEY_NAME = 'payment-initiation';

const paymentInitiationLocalStorageService = new LocalStorageService(KEY_NAME);

export { paymentInitiationLocalStorageService };
